import React, { Component } from 'react';
import gql from 'graphql-tag';
import gsap from 'gsap';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import playIcon from '../../../images/play-icon.svg';
import pauseIcon from '../../../images/pause-icon.svg';
import muteIcon from '../../../images/mute-icon.svg';
import unmuteIcon from '../../../images/unmute-icon.svg';

const GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
const RECIPROCAL_GR = 1 / GOLDEN_RATIO;
const DURATION = RECIPROCAL_GR;

class Member extends Component {
  constructor(props) {
    super(props);
    this.videoElement = null;
  }

  initializeVideoControls() {
    const videoBlock = document.querySelector('.pageTransition__slide .video-block');
    if (!videoBlock) return;

    const video = videoBlock.querySelector('.video-element');
    
    // Only initialize if we have a new video element
    if (!video || video === this.videoElement) return;
    
    this.videoElement = video;

    const placeholder = videoBlock.querySelector('.video-placeholder');
    const playPauseBtn = videoBlock.querySelector('.play-pause-btn');
    const playIcon = videoBlock.querySelector('.play-icon');
    const pauseIcon = videoBlock.querySelector('.pause-icon');
    const muteUnmuteBtn = videoBlock.querySelector('.mute-unmute-btn');
    const muteIcon = videoBlock.querySelector('.mute-icon');
    const unmuteIcon = videoBlock.querySelector('.unmute-icon');

    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          if (placeholder) placeholder.style.display = 'none';
          video.style.display = 'block';
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        } else {
          video.pause();
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        }
      });
    }

    if (muteUnmuteBtn) {
      muteUnmuteBtn.addEventListener('click', function() {
        if (video.muted) {
          video.muted = false;
          muteIcon.style.display = 'block';
          unmuteIcon.style.display = 'none';
        } else {
          video.muted = true;
          muteIcon.style.display = 'none';
          unmuteIcon.style.display = 'block';
        }
      });
    }
  }

  componentDidMount() {
    if (this.props.data.member && this.props.data.member.team.video) {
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => this.initializeVideoControls(), 100);
    }
  }

  componentDidUpdate() {
    if (this.props.data.member) {
      const mainInner = document.querySelector('.pageTransition__slide');
      gsap.to(mainInner, {
        autoAlpha: 1,
        duration: DURATION,
        ease: 'sine.out',
      });

      // Initialize video controls after render
      if (this.props.data.member.team.video) {
        setTimeout(() => this.initializeVideoControls(), 100);
      }
    }
  }

  componentWillUnmount() {
    // Reset video reference on unmount
    this.videoElement = null;
  }

  render() {
    const props = this.props;

    if (!props.data.member) {
      return <p className="hidden h-screen">Loading...</p>;
    }

    let url;
    try {
      if (props.data.member.team.social.url !== null) {
        url = props.data.member.team.social.url;
      }
    } catch (err) {
      console.log(err);
    }

    let title;
    try {
      if (props.data.member.team.social.title !== null) {
        title = props.data.member.team.social.title;
      }
    } catch (err) {
      console.log(err);
    }

    return (
      <section
        className={
          'pageTransition__slide pageTransition__slide--child z-50 bg-brand-cool-grey'
        }
      >
        <div className="grid lg:grid-cols-2 team-grid bg-white min-h-screen">
          <div
            className={`border-b border-brand-maroon row-start-3 lg:row-span-3 col-auto ${
              props.data.member.team.line != null
                ? 'lg:border-r lg:border-brand-black'
                : ''
            }`}
          >
            {props.data.member.featuredImage.node.sourceUrl ? (
              <img
                src={props.data.member.featuredImage.node.sourceUrl}
                alt={props.data.member.featuredImage.node.altText}
                className="object-cover h-full w-full"
              />
            ) : null}
          </div>
          <div className="border-b border-brand-maroon lg:border-0 text-brand-maroon lg:text-white bg-brand-cool-grey lg:bg-brand-maroon flex items-center justify-between lg:border-b p-brand-6 lg:p-brand-12">
            {props.data.member.team.position ? (
              <p className="text-lg lg:text-brand-2xl mb-0">
                {props.data.member.team.position}
              </p>
            ) : null}
            <Link to="/team/" className="cursor-pointer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="none"
                className="w-5 xl:w-8 stroke-current ml-2"
                viewBox="0 0 26 26"
              >
                <path
                  stroke="currentColor"
                  strokeWidth="1.5"
                  d="M0 -0.75L33.951 -0.75"
                  transform="matrix(.7071 .7071 -.64087 .76765 1 2)"
                ></path>
                <path
                  stroke="currentColor"
                  strokeWidth="1.5"
                  d="M0 -0.75L33.941 -0.75"
                  transform="matrix(.7071 -.7071 .64087 .76765 1 26)"
                ></path>
              </svg>
            </Link>
          </div>
          <div className="bg-brand-cool-grey lg:bg-brand-maroon lg:row-span-2">
            <div className="flex flex-col justify-between p-brand-6 lg:p-brand-12 h-full">
              {props.data.member.title ? (
                <h1 className="text-brand-2xl text-brand-maroon lg:text-white lg:text-brand-7xl mb-brand-6 lg:m-0 max-w-sm">
                  {props.data.member.title}
                </h1>
              ) : null}
            </div>
          </div>
        </div>
        <div className="px-brand-6 lg:px-brand-12 pb-brand-12 lg:pb-0 lg:px-0 flex flex-wrap lg:flex-no-wrap">
          <div className="w-full lg:w-1/2 py-brand-12">
            <div className="flex flex-wrap lg:flex-no-wrap gap-4">
              <div className="w-full lg:w-auto mb-brand-12 lg:m-0">
                {props.data.member.team.email != null ? (
                  <React.Fragment>
                    <p className="mb-2 text-xs lg:text-sm">Email</p>
                    <a
                      className="text-brand-blood-orange text-lg lg:text-brand-2xl leading-tight brand-link"
                      href={`mailto:${props.data.member.team.email}`}
                    >
                      {props.data.member.team.email}
                    </a>
                  </React.Fragment>
                ) : null}
              </div>
              <div className="w-full lg:w-auto">
                {props.data.member.team.social != undefined ? (
                  <React.Fragment>
                    <p className="mb-2 text-xs lg:text-sm">Social</p>
                    <a
                      className="text-brand-blood-orange text-lg lg:text-brand-2xl leading-tight brand-link"
                      href={url}
                      target="blank"
                    >
                      {title}
                    </a>
                  </React.Fragment>
                ) : null}
              </div>
            </div>
            {props.data.member.team.video && (
              <div className="w-full mt-brand-12">
                <div className="video-block page-builder-video-block mb-brand-6">
                  <div className="video-container w-full">
                    {props.data.member.team.videoPlaceholderImage && (
                      <img
                        src={props.data.member.team.videoPlaceholderImage.sourceUrl}
                        alt={props.data.member.team.videoPlaceholderImage.altText || 'Video placeholder'}
                        className="video-placeholder object-contain"
                      />
                    )}
                    <video
                      className="video-element object-contain"
                      src={props.data.member.team.video.mediaItemUrl}
                      preload="metadata"
                    ></video>
                    <div className="video-controls">
                      <button className="play-pause-btn" aria-label="Play/Pause">
                        <img
                          src={playIcon}
                          alt="Play"
                          className="play-icon"
                        />
                        <img
                          src={pauseIcon}
                          alt="Pause"
                          className="pause-icon"
                          style={{ display: 'none' }}
                        />
                      </button>
                      <button className="mute-unmute-btn" aria-label="Mute/Unmute">
                        <img
                          src={muteIcon}
                          alt="Mute"
                          className="mute-icon"
                        />
                        <img
                          src={unmuteIcon}
                          alt="Unmute"
                          className="unmute-icon"
                          style={{ display: 'none' }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="w-full lg:w-1/2 p-0 lg:p-brand-12">
            {props.data.member.content ? (
              <React.Fragment>
                <p className="mb-2 text-xs lg:text-sm">Bio</p>
                <div
                  dangerouslySetInnerHTML={{
                    __html: props.data.member.content,
                  }}
                ></div>
              </React.Fragment>
            ) : null}
          </div>
        </div>
        <section className="mb-0">
          {props.data.member.team.posts && (
            <div className="border-b border-brand-maroon mb-brand-12">
              <div className="px-brand-6 lg:px-brand-12 flex justify-between items-center my-brand-6 lg:my-brand-12">
                <h2 className="text-brand-2xl xl:text-brand-4xl">
                  RELATED CONTENT
                </h2>
              </div>
            </div>
          )}
          <div className="flex flex-wrap xl:flex-no-wrap -mx-brand-6 px-brand-6 lg:px-brand-12">
            {props.data.member.team.posts &&
              props.data.member.team.posts.map(function (item, index) {
                return (
                  <article
                    key={index}
                    className="w-full md:w-1/2 xl:w-1/3 px-brand-6 mb-brand-12 xl:mb-brand-24"
                  >
                    {item.image.sourceUrl ? (
                      <img
                        src={item.image.sourceUrl}
                        alt={item.image.altText}
                        className="object-cover w-full"
                      />
                    ) : null}
                    <h1 className="text-lg xl:text-brand-2xl text-black tracking-brand-tightest leading-snug my-4">
                      {item.heading}
                    </h1>
                    <a
                      href={item.link.url}
                      target="blank"
                      className="brand-link block text-brand-blood-orange inline-flex items-center text-lg xl:text-brand-2xl tracking-brand-tightest"
                    >
                      Read More
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="none"
                        viewBox="0 0 25 25"
                        className=" ml-3"
                      >
                        <path
                          stroke="#D9503D"
                          strokeWidth="1.5"
                          d="M0 12.502h23M11.103 24l11.896-11.5L11.103 1"
                        ></path>
                      </svg>
                    </a>
                  </article>
                );
              })}
          </div>
        </section>
      </section>
    );
  }
}

const GetMemberBySlug = gql`
  query getMemberBySlug($slug: String) {
    member: memberBy(uri: $slug) {
      title
      content
      team {
        email
        position
        line
        social {
          title
          target
          url
        }
        posts {
          heading
          image {
            altText
            sourceUrl
          }
          link {
            url
            title
            target
          }
        }
        video {
          mediaItemUrl
        }
        videoPlaceholderImage {
          altText
          sourceUrl
        }
      }
      featuredImage {
        node {
          altText
          sourceUrl
        }
      }
    }
  }
`;

export default graphql(GetMemberBySlug, {
  options: (props) => {
    const slug = props.match.params.slug;
    return {
      variables: {
        slug,
      },
    };
  },
})(Member);



// WEBPACK FOOTER //
// ./scripts/components/Team/Member.jsx